export const steps = ['Base', 'Oferta', 'Demanda', 'Prioridades', 'Recomendacion', 'Cotizacion'];

export const investmentRanges = [
  'Menos de $1,500',
  '$1,500 - $3,000',
  '$3,000 - $6,000',
  '$6,000 - $12,000',
  '$12,000 - $25,000',
  'Mas de $25,000',
];

export const businessTypes = ['Startup', 'Pyme', 'Empresa consolidada', 'Consultor', 'Marca personal', 'Otro'];

export const horizons = [
  'Necesito moverme ya',
  'En las proximas 2 semanas',
  'Este mes',
  'En 30 a 60 dias',
  'Estoy planificando',
];

export const objectiveOptions = [
  'Construir marca',
  'Captar mas clientes',
  'Ordenar ventas',
  'Escalar operacion',
  'Todo el recorrido',
];

export const urgencyOptions = [
  'Necesito salir al mercado mejor presentado',
  'Necesito trafico y prospectos',
  'Necesito convertir mejor lo que ya llega',
  'Necesito ordenar la operacion para crecer',
];

export const servicePriorities = [
  'Presencia y marca',
  'SEO y contenidos',
  'Anuncios y captacion',
  'Nutricion y seguimiento',
  'Conversion comercial',
  'Automatizacion y escalabilidad',
];

export const stageCatalog = [
  {
    id: 'fase1',
    title: 'Etapa 1: Creacion de marca',
    color: '#6C4DE2',
    summary: 'Construimos la base visible y comercial de la marca para que todo lo demas tenga traccion.',
    services: [
      {
        id: 'marca-investigacion',
        name: 'Investigacion de mercado',
        description: 'Analisis del mercado, competencia, oportunidad y enfoque comercial.',
        time: '3 a 5 dias',
        price: 420,
        details: 'Define hacia donde debe apuntar la marca y con que lenguaje competir.',
      },
      {
        id: 'marca-arquitectura',
        name: 'Propuesta de valor y arquitectura de mensajes',
        description: 'Ordenamos promesa, oferta, diferenciales y narrativa base.',
        time: '2 a 4 dias',
        price: 360,
        details: 'Sirve como columna vertebral de web, brochure, anuncios y contenidos.',
      },
      {
        id: 'marca-branding',
        name: 'Branding visual y mensajes base',
        description: 'Identidad visual, tono, estilo grafico y base comunicacional.',
        time: '4 a 6 dias',
        price: 650,
        details: 'Incluye lineamiento de marca para que todo salga con coherencia.',
      },
      {
        id: 'marca-web',
        name: 'Pagina web comercial inicial',
        description: 'Sitio base con estructura comercial y enfoque en conversion.',
        time: '2 a 4 semanas',
        price: 1800,
        details: 'Incluye estructura, copy principal, secciones clave y armado inicial.',
      },
      {
        id: 'marca-redes',
        name: 'Configuracion inicial de redes sociales',
        description: 'Armamos perfiles, lineamientos y presencia lista para publicar.',
        time: '5 a 7 dias',
        price: 520,
        details: 'Deja redes alineadas con la marca y listas para activacion organica o paga.',
      },
      {
        id: 'marca-brochure',
        name: 'Brochure y diapositivas comerciales',
        description: 'Material institucional para presentar la marca y vender mejor.',
        time: '3 a 5 dias',
        price: 480,
        details: 'Ideal para reuniones, alianzas y presentaciones de venta.',
      },
      {
        id: 'marca-spots',
        name: 'Spots publicitarios iniciales',
        description: 'Piezas base para presentar la marca en video o anuncios.',
        time: '4 a 7 dias',
        price: 540,
        details: 'Sirve como punto de partida para campanas y contenido audiovisual.',
      },
      {
        id: 'marca-analytics',
        name: 'Sincronizacion con analitica',
        description: 'Conexion con medicion para entender trafico, origen y conversion.',
        time: '1 a 2 dias',
        price: 240,
        details: 'Integra pixeles, eventos y herramientas base de analitica.',
      },
      {
        id: 'marca-blog',
        name: 'Articulos iniciales del blog',
        description: 'Publicamos contenido base para arrancar autoridad y SEO.',
        time: '3 a 6 dias',
        price: 390,
        details: 'Se entrega como paquete inicial para abrir el canal organico.',
      },
    ],
  },
  {
    id: 'fase2',
    title: 'Etapa 2: Generacion inteligente',
    color: '#F21C63',
    summary: 'Movemos trafico, atencion y demanda hacia la maquina comercial.',
    services: [
      {
        id: 'gen-seo',
        name: 'SEO y optimizacion on-page',
        description: 'Base organica para posicionar mejor y traer trafico con estructura.',
        time: '4 a 6 dias',
        price: 560,
        details: 'Incluye mapa SEO inicial, ajustes on-page y oportunidades principales.',
      },
      {
        id: 'gen-google',
        name: 'Campanas en Google Ads',
        description: 'Captacion activa de trafico con intencion comercial.',
        time: 'Continuo',
        price: 740,
        details: 'Valor de gestion mensual. No incluye pauta publicitaria.',
      },
      {
        id: 'gen-social',
        name: 'Campanas en redes sociales',
        description: 'Distribucion paga para visibilidad, alcance y prospectos.',
        time: 'Continuo',
        price: 690,
        details: 'Valor de gestion mensual. No incluye pauta publicitaria.',
      },
      {
        id: 'gen-blog',
        name: 'Creacion continua de articulos del blog',
        description: 'Contenido recurrente para autoridad, SEO y demanda organica.',
        time: 'Continuo',
        price: 320,
        details: 'Valor referencial por paquete mensual de articulos.',
      },
      {
        id: 'gen-reels',
        name: 'Reels y piezas cortas de atraccion',
        description: 'Contenido audiovisual pensado para alcance y recordacion.',
        time: 'Continuo',
        price: 410,
        details: 'Ideal para redes que dependen de frecuencia y ritmo de publicacion.',
      },
      {
        id: 'gen-imagenes',
        name: 'Imagenes y creatividades para campanas',
        description: 'Piezas graficas listas para anuncios, publicaciones y remarketing.',
        time: 'Continuo',
        price: 360,
        details: 'Funciona como soporte visual para trafico continuo y activaciones.',
      },
    ],
  },
  {
    id: 'fase3',
    title: 'Etapa 3: Nutricion estrategica',
    color: '#0B8DB5',
    summary: 'Convertimos interes frio en conversacion mas madura y comercial.',
    services: [
      {
        id: 'nutri-mapa',
        name: 'Mapa de nutricion por etapas',
        description: 'Definimos que recibe cada lead segun interes, temperatura y momento.',
        time: '2 a 4 dias',
        price: 290,
        details: 'Organiza la experiencia para que cada contacto reciba lo correcto.',
      },
      {
        id: 'nutri-email',
        name: 'Secuencias de email marketing',
        description: 'Automatizacion para educar, madurar y activar interes.',
        time: '5 a 7 dias',
        price: 520,
        details: 'Incluye arquitectura, copy, disparadores y entregables principales.',
      },
      {
        id: 'nutri-score',
        name: 'Calificacion de oportunidades',
        description: 'Priorizacion de leads con mayor intencion o ajuste comercial.',
        time: '3 a 5 dias',
        price: 410,
        details: 'Ayuda a ventas a enfocarse mejor y perder menos tiempo.',
      },
      {
        id: 'nutri-whatsapp',
        name: 'Secuencias por WhatsApp',
        description: 'Mensajes de seguimiento para mantener respuesta y avance.',
        time: '3 a 5 dias',
        price: 370,
        details: 'Se puede integrar con CRM o con flujos manuales asistidos.',
      },
      {
        id: 'nutri-recuperacion',
        name: 'Recuperacion de leads frios',
        description: 'Reactivacion de contactos detenidos o sin cierre.',
        time: '3 a 5 dias',
        price: 360,
        details: 'Monetiza mejor bases ya existentes y oportunidades dormidas.',
      },
      {
        id: 'nutri-followup',
        name: 'Seguimiento inteligente multicanal',
        description: 'Coordinacion entre email, WhatsApp, CRM y equipo comercial.',
        time: '4 a 6 dias',
        price: 470,
        details: 'Se integra al seguimiento comercial y mejora consistencia.',
      },
    ],
  },
  {
    id: 'fase4',
    title: 'Etapa 4: Conversion digital',
    color: '#FFB800',
    summary: 'Reducimos fuga comercial y elevamos el paso de reunion a cierre.',
    services: [
      {
        id: 'conv-diagnostico',
        name: 'Diagnostico del proceso comercial',
        description: 'Revision de fugas, objeciones y puntos de abandono.',
        time: '2 a 3 dias',
        price: 320,
        details: 'Detecta mejoras antes de invertir mas en trafico o automatizacion.',
      },
      {
        id: 'conv-scripts',
        name: 'Scripts y respuestas por objecion',
        description: 'Guiones para reuniones, mensajes, seguimiento y cierres.',
        time: '2 a 4 dias',
        price: 390,
        details: 'Ideal para ventas consultivas, setters o cierres digitales.',
      },
      {
        id: 'conv-propuesta',
        name: 'Estructura de propuesta comercial',
        description: 'Ordenamos la oferta final para que sea mas facil avanzar a cierre.',
        time: '2 a 4 dias',
        price: 350,
        details: 'Incluye narrativa, bloques de valor y secuencia de presentacion.',
      },
      {
        id: 'conv-setter',
        name: 'Sistema de setter digital',
        description: 'Precalificacion y orden del flujo de reuniones.',
        time: 'Continuo',
        price: 650,
        details: 'Gestion mensual o implementacion del sistema de agendado y filtro.',
      },
      {
        id: 'conv-confirmacion',
        name: 'Confirmacion y no-show control',
        description: 'Flujos para reducir cancelaciones y mejorar asistencia.',
        time: '2 a 3 dias',
        price: 280,
        details: 'Se integra con seguimiento previo a la reunion.',
      },
      {
        id: 'conv-cierre',
        name: 'Proceso de propuesta y cierre',
        description: 'Paso de reunion a propuesta, seguimiento y cierre final.',
        time: '3 a 5 dias',
        price: 580,
        details: 'Incluye estructura comercial, tiempos de seguimiento y cierre.',
      },
    ],
  },
  {
    id: 'fase5',
    title: 'Etapa 5: Escalabilidad',
    color: '#2ECC71',
    summary: 'Ordenamos la maquina para que pueda crecer con menos friccion y mas margen.',
    services: [
      {
        id: 'esc-diagnostico',
        name: 'Diagnostico operativo',
        description: 'Cuellos de botella, fugas de tiempo y prioridades reales.',
        time: '3 a 5 dias',
        price: 430,
        details: 'Ordena la hoja de ruta para escalar sin romper la operacion.',
      },
      {
        id: 'esc-integraciones',
        name: 'Integracion de tecnologias',
        description: 'Conexion de marketing, ventas, CRM y operaciones.',
        time: '1 a 2 semanas',
        price: 980,
        details: 'Incluye conexiones, pruebas base y lectura general del flujo.',
      },
      {
        id: 'esc-automatizacion',
        name: 'Automatizacion operativa',
        description: 'Menos tareas manuales, menos errores y mas consistencia.',
        time: '5 a 10 dias',
        price: 760,
        details: 'Puede abarcar alertas, handoff, reglas y automatismos clave.',
      },
      {
        id: 'esc-reportes',
        name: 'Reportes y tableros de control',
        description: 'Visibilidad ejecutiva para tomar decisiones con datos.',
        time: '3 a 5 dias',
        price: 410,
        details: 'Unifica lectura comercial, operativa y de seguimiento.',
      },
      {
        id: 'esc-estandarizacion',
        name: 'Estandarizacion de procesos',
        description: 'Documentamos y ordenamos como debe funcionar la maquina.',
        time: '4 a 7 dias',
        price: 520,
        details: 'Ayuda a crecer con mas equipo y menos dependencia de personas clave.',
      },
      {
        id: 'esc-software',
        name: 'Software a medida',
        description: 'Pieza propia cuando ya no basta con herramientas sueltas.',
        time: '3 a 8 semanas',
        price: 2400,
        details: 'El valor se ajusta segun alcance, modulos y complejidad final.',
      },
    ],
  },
];

export const recommendationMap = {
  'Construir marca': ['marca-investigacion', 'marca-arquitectura', 'marca-branding', 'marca-web', 'marca-redes'],
  'Captar mas clientes': ['gen-seo', 'gen-google', 'gen-social', 'gen-blog', 'gen-reels'],
  'Ordenar ventas': ['nutri-email', 'nutri-score', 'conv-scripts', 'conv-propuesta', 'conv-cierre'],
  'Escalar operacion': ['esc-diagnostico', 'esc-integraciones', 'esc-automatizacion', 'esc-reportes'],
  'Todo el recorrido': ['marca-branding', 'gen-google', 'nutri-email', 'conv-cierre', 'esc-integraciones'],
};

export const formatCurrency = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(Number.isFinite(value) ? value : 0);

const toPercent = (val) => Number(val || 0) / 100;

// Helper to handle relative values (e.g. "40%" of the ticket)
const parseQuantity = (val, relativeTo = 0) => {
  const str = String(val || '');
  if (str.endsWith('%')) {
    const percent = parseFloat(str.replace('%', '')) || 0;
    return (percent / 100) * relativeTo;
  }
  return Number(str) || 0;
};

export const calculateBusinessMetrics = (values) => {
  const ticket = Number(values.ticket || 0);
  const recurringPayments = Number(values.recurringPayments || 0);
  const recurringValue = Number(values.recurringValue || 0);
  
  // Soporte para porcentajes relativos al ticket
  const productionCost = parseQuantity(values.productionCost, ticket);
  const newClients = Number(values.newClients || 0);
  const marketingPercent = Number(String(values.marketingPercent || '').replace('%', '')) || 0;
  
  const closeRate = Number(String(values.closeRate || '').replace('%', '')) || 0;
  const marketCpl = Number(values.marketCpl || 0);

  const ltv = ticket + recurringPayments * recurringValue;
  const grossProfitPerClient = ltv - productionCost;
  const projectedRealProfit = grossProfitPerClient * newClients;
  const investmentPerClient = grossProfitPerClient * toPercent(marketingPercent);
  const totalInvestmentBudget = investmentPerClient * newClients;
  const cpaMax = investmentPerClient;
  const leadsNeeded = closeRate > 0 ? Math.ceil(newClients / toPercent(closeRate)) : 0;
  const cplMax = leadsNeeded > 0 ? totalInvestmentBudget / leadsNeeded : 0;
  const grossRevenueTotal = ltv * newClients;
  const totalProductionCost = productionCost * newClients;
  const marketingServicesBudget = totalInvestmentBudget * 0.4;
  const finalNetProfit = grossRevenueTotal - totalProductionCost - totalInvestmentBudget;
  const profitAfterAllCosts = finalNetProfit - marketingServicesBudget;
  const roi = totalInvestmentBudget > 0 ? finalNetProfit / totalInvestmentBudget : 0;
  
  const mathIsProfitable = grossProfitPerClient > 0 && finalNetProfit > 0;
  const cplIsViable = marketCpl > 0 ? (cplMax >= marketCpl) : true;
  const hasData = ticket > 0 && closeRate > 0 && newClients > 0;

  const viable = mathIsProfitable && cplIsViable && hasData;

  return {
    ticket,
    recurringPayments,
    recurringValue,
    ltv,
    productionCost,
    grossProfitPerClient,
    newClients,
    projectedRealProfit,
    marketingPercent,
    investmentPerClient,
    totalInvestmentBudget,
    closeRate,
    cpaMax,
    leadsNeeded,
    cplMax,
    marketCpl,
    viable,
    grossRevenueTotal,
    totalProductionCost,
    marketingServicesBudget,
    finalNetProfit,
    profitAfterAllCosts,
    roi,
    verdictLabel: viable ? 'VIABLE' : (mathIsProfitable ? 'AJUSTADO' : 'NO VIABLE'),
    businessState: viable ? 'RENTABLE' : (mathIsProfitable ? 'EN REVISION' : 'EN RIESGO'),
  };
};
